import React from "react";

import { Button } from "components/ui/button";

export const UploadActions = ({
  selectedFile,
  isFileInvalid,
  isFileTooLarge,
  uploadError,
  onUpload,
  onCancel,
}) => {
  return (
    <div className="space-y-3">
      {uploadError && (
        <div className="rounded-md border border-red-200 bg-red-50 p-3 text-sm text-red-700">
          {uploadError}
        </div>
      )}

      {selectedFile && !isFileInvalid && !isFileTooLarge && (
        <div className="flex justify-end gap-8">
          <Button
            variant="outline"
            disabled={!selectedFile || isFileInvalid || isFileTooLarge}
            onClick={onCancel}
          >
            Cancel
          </Button>

          <Button
            disabled={!selectedFile || isFileInvalid || isFileTooLarge}
            onClick={onUpload}
            className="!bg-[#0FA4E8]"
          >
            Create talent profile
          </Button>
        </div>
      )}
    </div>
  );
};
